import React, { FunctionComponent } from 'react';
import './page-loader.scss';

import { ProgressSpinner } from '@dxlm/components';

const PageLoaderPage: FunctionComponent = () => {
    return (
        <div className='page-loader-container absolute-full-page flex-center'>
            <ProgressSpinner />
        </div>
    )
};

export default PageLoaderPage;